import { createContext, useContext, type ReactNode } from "react";

export interface EmbedUiContextValue {
  /** Compact top-bar embed layout — enables the playful thought-bubble chrome. */
  compactDesign: boolean;
}

const EmbedUiContext = createContext<EmbedUiContextValue>({ compactDesign: false });

export function EmbedUiProvider({
  compactDesign,
  children,
}: {
  compactDesign: boolean;
  children: ReactNode;
}) {
  return (
    <EmbedUiContext.Provider value={{ compactDesign }}>
      {children}
    </EmbedUiContext.Provider>
  );
}

/** True inside the compact embed layout (new design). */
export function useEmbedUi(): EmbedUiContextValue {
  return useContext(EmbedUiContext);
}
